import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { DEFAULT_FONT_FAMILY } from '@constants/common/ui.constants';

interface Params {
  isError: boolean;
}

const useStyles = makeStyles<Params>()((theme, { isError }) => {
  const placeHolderColor = theme.palette.custom.text.accent;
  const inputColor = theme.palette.custom.text.dark;
  const borderRadius = theme.borderRadius.lg;

  return {
    root: {
      width: '100%',
      position: 'relative',
    },

    formControl: {
      width: '100%',
    },
    disabledBox: {
      opacity: 0.48,
      pointerEvents: 'none',

      '& .MuiFormHelperText-root': {
        span: {
          color: inputColor,
        },
      },
    },
    input: {
      background: theme.palette.custom.elements.primary,
      transition: 'all 0.25s ease-in-out',
      borderRadius,

      '& input': {
        boxSizing: 'border-box',
        fontSize: 16,
        lineHeight: '24px',
        fontWeight: 400,
        fontFamily: DEFAULT_FONT_FAMILY,
        color: inputColor,
        height: 45,
        borderRadius,

        '&.MuiInputBase-inputSizeSmall': {
          height: 44,
          minHeight: 44,
        },

        '&::placeholder': {
          fontSize: 16,
          color: placeHolderColor,
          opacity: 1,
        },

        '&:focus': {
          caretColor: inputColor,
          backgroundColor: theme.palette.custom.elements.primaryHover,
        },

        '&:hover': {
          color: placeHolderColor,
          backgroundColor: theme.palette.custom.elements.primaryHover,
        },
      },

      '& .MuiOutlinedInput-root': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent',
        },

        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent',
        },

        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: `1px solid ${theme.palette.custom.border.primary}`,
          borderRadius,
          color: inputColor,

          '& input': {
            color: inputColor,
          },
        },

        '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent',

          '& input': {
            color: inputColor,
          },
        },
      },

      '&:hover': {
        '& input': {
          color: inputColor,

          '&::placeholder': {
            color: placeHolderColor,
          },
        },

        '& .MuiSvgIcon-root': {
          color: inputColor,
        },
      },
    },
    supportText: {
      paddingTop: 4,
      lineHeight: 1,
    },

    error: {
      right: 0,
      marginRight: 'auto',

      '& span': {
        color: theme.palette.custom.accent.error,
      },
    },
    errorBox: {
      '.MuiFormLabel-root': {
        color: inputColor,
      },

      '&:hover .MuiFormLabel-root': {
        color: inputColor,
      },

      '& .MuiFormLabel-root': {
        color: placeHolderColor,

        '&.Mui-focused': {
          color: inputColor,
          backgroundColor: theme.palette.custom.elements.primaryHover,
        },
      },

      '& .MuiOutlinedInput-root': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderRadius,
          borderColor: theme.palette.custom.accent.error,
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.custom.accent.error,
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: `${theme.palette.custom.accent.error} !important`,
        },
      },

      '& input': {
        color: inputColor,
        caretColor: `${inputColor} !important`,
      },
    },

    buttonMax: {
      textTransform: 'capitalize',
      backgroundColor: 'transparent',
      border: 'none',
      color: placeHolderColor,
      cursor: 'pointer',

      '&:hover': {
        opacity: '0.7',
      },

      '&:active': {
        opacity: '0.5',
      },

      '&:disabled': {
        pointerEvents: 'none',
        opacity: 0.38,
      },
    },

    searchIcon: {
      ...dFlex(),
      color: inputColor,
      width: 28,
    },
    actionsBox: {
      ...dFlex(),
      gap: 12,
      position: 'absolute',
      right: '10px',
      top: '50%',
      transform: 'translate(0, -50%)',

      ...(isError && {
        top: '33%',
        transform: 'translate(0, -50%)',
      }),
    },
  };
});

export default useStyles;
